// @flow
import React from 'react';

import { COLORS } from 'Components/utils/color/colors';

import { Text } from 'Components/frameworks/text/Text.jsx';

export type ProductFeatureDetailServiceItemProps = {
  className?: string,
  description?: string,
  items?: Array<ProductFeatureDetailServiceItemProps>,
  label?: string,
  note?: string,
  tag?: { color?: Colors, label: string },
};

export function ProductFeatureDetailServiceItem(props: ProductFeatureDetailServiceItemProps) {
  const { className, description, items = [], label, note, tag = {} } = props;

  return (
    <li className={className}>
      {!!label && <div className="font-bold">{label}</div>}
      {!!description && <Text className="inline-block mb-1" text={description} />}
      {!!tag?.label && (
        <span className={`font-bold text-${tag.color || COLORS.GRAY_DARKER} mb-1`}>
          {` ${tag.label}`}
        </span>
      )}
      {!!note && <small className="block">{note}</small>}
      {!!items.length && (
        <ul className="list-none p-0 leading-normal text-base text-gray-darker">
          {items.map((item, i) => (
            <ProductFeatureDetailServiceItem
              className="list-hyphen"
              description={item.description}
              index={i}
              items={item.items}
              key={item.description}
              label={item.label}
              note={item.note}
              tag={item.tag}
            />
          ))}
        </ul>
      )}
    </li>
  );
}
